import { render, staticRenderFns } from "./UserMiniAvatar.vue?vue&type=template&id=94324732&"
import script from "./UserMiniAvatar.vue?vue&type=script&lang=js&"
export * from "./UserMiniAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports